unit View.Lancamentos.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UConstantes, UUtils;

type
  TFViewLancamentosList = class(TForm)
    btNew: TButton;
    LancamentosDataset: TXDataWebDataSet;
    LancamentosDatasetid: TIntegerField;
    LancamentosDatasetaliado_id: TIntegerField;
    LancamentosDatasetdata_base_id: TIntegerField;
    LancamentosDatasetcliente_id: TIntegerField;
    LancamentosDatasetfornecedor_id: TIntegerField;
    LancamentosDatasetmodalidade_id: TIntegerField;
    LancamentosDatasetplano_contas_id: TIntegerField;
    LancamentosDatasetconta_origem_id: TIntegerField;
    LancamentosDatasetconta_destino_id: TIntegerField;
    LancamentosDatasetfuncionario_id: TIntegerField;
    LancamentosDatasetdocumento: TStringField;
    LancamentosDatasethistorico: TStringField;
    LancamentosDatasetlancamento_credito: TBooleanField;
    LancamentosDatasetlancamento_estorno: TBooleanField;
    LancamentosDatasetlancamento_prazo: TBooleanField;
    LancamentosDatasetdata_emissao: TDateTimeField;
    LancamentosDatasetdata_vencimento: TDateTimeField;
    LancamentosDatasetdata_pagamento: TDateTimeField;
    LancamentosDatasetvalor: TFloatField;
    LancamentosDatasetobservacoes: TStringField;
    LancamentosDatasetsaldo_inicial_origem: TFloatField;
    LancamentosDatasetsaldo_inicial_destino: TFloatField;
    LancamentosDatasetcodigo_interno: TIntegerField;
    LancamentosDatasetexcluido: TBooleanField;
    LancamentosDatasetinclusao: TDateTimeField;
    LancamentosDatasetalteracao: TDateTimeField;
    LancamentosDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewLancamentosList: TFViewLancamentosList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewLancamentosList }

procedure TFViewLancamentosList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewLancamentosList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewLancamentosList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewLancamentosList, AElementID, Result, @AfterCreate);
end;

procedure TFViewLancamentosList.edSearchKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
    FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewLancamentosList.edSearchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewLancamentosList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewLancamentosList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewLancamentosList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      LancamentosDataset.Connection.Model.DefaultSchema.FindEntityType(LancamentosDataset.EntitySetName),
      LancamentosDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewLancamentosList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('lancamentos', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    LancamentosDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewLancamentosList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.lancamentos.list.pagination.info');
  btNew := TButton.Create('view.lancamentos.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.lancamentos.list.table');
  cbPageSize := TComboBox.Create('view.lancamentos.list.cbPageSize');
  edSearch := TEdit.Create('view.lancamentos.list.search');
  lcPaginator := TListControl.Create('view.lancamentos.list.pagination');
  LancamentosDataset := TXDataWebDataSet.Create(Self);
  LancamentosDatasetid := TIntegerField.Create(Self);
  LancamentosDatasetaliado_id := TIntegerField.Create(Self);
  LancamentosDatasetdata_base_id := TIntegerField.Create(Self);
  LancamentosDatasetcliente_id := TIntegerField.Create(Self);
  LancamentosDatasetfornecedor_id := TIntegerField.Create(Self);
  LancamentosDatasetmodalidade_id := TIntegerField.Create(Self);
  LancamentosDatasetplano_contas_id := TIntegerField.Create(Self);
  LancamentosDatasetconta_origem_id := TIntegerField.Create(Self);
  LancamentosDatasetconta_destino_id := TIntegerField.Create(Self);
  LancamentosDatasetfuncionario_id := TIntegerField.Create(Self);
  LancamentosDatasetdocumento := TStringField.Create(Self);
  LancamentosDatasethistorico := TStringField.Create(Self);
  LancamentosDatasetlancamento_credito := TBooleanField.Create(Self);
  LancamentosDatasetlancamento_estorno := TBooleanField.Create(Self);
  LancamentosDatasetlancamento_prazo := TBooleanField.Create(Self);
  LancamentosDatasetdata_emissao := TDateTimeField.Create(Self);
  LancamentosDatasetdata_vencimento := TDateTimeField.Create(Self);
  LancamentosDatasetdata_pagamento := TDateTimeField.Create(Self);
  LancamentosDatasetvalor := TFloatField.Create(Self);
  LancamentosDatasetobservacoes := TStringField.Create(Self);
  LancamentosDatasetsaldo_inicial_origem := TFloatField.Create(Self);
  LancamentosDatasetsaldo_inicial_destino := TFloatField.Create(Self);
  LancamentosDatasetcodigo_interno := TIntegerField.Create(Self);
  LancamentosDatasetexcluido := TBooleanField.Create(Self);
  LancamentosDatasetinclusao := TDateTimeField.Create(Self);
  LancamentosDatasetalteracao := TDateTimeField.Create(Self);
  LancamentosDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  LancamentosDataset.BeforeLoadDFMValues;
  LancamentosDatasetid.BeforeLoadDFMValues;
  LancamentosDatasetaliado_id.BeforeLoadDFMValues;
  LancamentosDatasetdata_base_id.BeforeLoadDFMValues;
  LancamentosDatasetcliente_id.BeforeLoadDFMValues;
  LancamentosDatasetfornecedor_id.BeforeLoadDFMValues;
  LancamentosDatasetmodalidade_id.BeforeLoadDFMValues;
  LancamentosDatasetplano_contas_id.BeforeLoadDFMValues;
  LancamentosDatasetconta_origem_id.BeforeLoadDFMValues;
  LancamentosDatasetconta_destino_id.BeforeLoadDFMValues;
  LancamentosDatasetfuncionario_id.BeforeLoadDFMValues;
  LancamentosDatasetdocumento.BeforeLoadDFMValues;
  LancamentosDatasethistorico.BeforeLoadDFMValues;
  LancamentosDatasetlancamento_credito.BeforeLoadDFMValues;
  LancamentosDatasetlancamento_estorno.BeforeLoadDFMValues;
  LancamentosDatasetlancamento_prazo.BeforeLoadDFMValues;
  LancamentosDatasetdata_emissao.BeforeLoadDFMValues;
  LancamentosDatasetdata_vencimento.BeforeLoadDFMValues;
  LancamentosDatasetdata_pagamento.BeforeLoadDFMValues;
  LancamentosDatasetvalor.BeforeLoadDFMValues;
  LancamentosDatasetobservacoes.BeforeLoadDFMValues;
  LancamentosDatasetsaldo_inicial_origem.BeforeLoadDFMValues;
  LancamentosDatasetsaldo_inicial_destino.BeforeLoadDFMValues;
  LancamentosDatasetcodigo_interno.BeforeLoadDFMValues;
  LancamentosDatasetexcluido.BeforeLoadDFMValues;
  LancamentosDatasetinclusao.BeforeLoadDFMValues;
  LancamentosDatasetalteracao.BeforeLoadDFMValues;
  LancamentosDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  try
    Name := 'FViewLancamentosList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'data_base_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cliente_id';
      Title := 'cliente_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'fornecedor_id';
      Title := 'fornecedor_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'modalidade_id';
      Title := 'modalidade_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'plano_contas_id';
      Title := 'plano_contas_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'conta_origem_id';
      Title := 'conta_origem_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'conta_destino_id';
      Title := 'conta_destino_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'funcionario_id';
      Title := 'funcionario_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'documento';
      Title := 'documento';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'historico';
      Title := 'historico';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'lancamento_credito';
      Title := 'lancamento_credito';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'lancamento_estorno';
      Title := 'lancamento_estorno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'lancamento_prazo';
      Title := 'lancamento_prazo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_emissao';
      Title := 'data_emissao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_vencimento';
      Title := 'data_vencimento';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_pagamento';
      Title := 'data_pagamento';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor';
      Title := 'valor';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'observacoes';
      Title := 'observacoes';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'saldo_inicial_origem';
      Title := 'saldo_inicial_origem';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'saldo_inicial_destino';
      Title := 'saldo_inicial_destino';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    LancamentosDataset.SetParentComponent(Self);
    LancamentosDataset.Name := 'LancamentosDataset';
    LancamentosDataset.EntitySetName := 'Lancamentos';
    LancamentosDataset.Connection := DMConnection.ApiConnection;
    LancamentosDataset.Left := 72;
    LancamentosDataset.Top := 144;
    LancamentosDatasetid.SetParentComponent(LancamentosDataset);
    LancamentosDatasetid.Name := 'LancamentosDatasetid';
    LancamentosDatasetid.FieldName := 'id';
    LancamentosDatasetid.Required := True;
    LancamentosDatasetaliado_id.SetParentComponent(LancamentosDataset);
    LancamentosDatasetaliado_id.Name := 'LancamentosDatasetaliado_id';
    LancamentosDatasetaliado_id.FieldName := 'aliado_id';
    LancamentosDatasetaliado_id.Required := True;
    LancamentosDatasetdata_base_id.SetParentComponent(LancamentosDataset);
    LancamentosDatasetdata_base_id.Name := 'LancamentosDatasetdata_base_id';
    LancamentosDatasetdata_base_id.FieldName := 'data_base_id';
    LancamentosDatasetdata_base_id.Required := True;
    LancamentosDatasetcliente_id.SetParentComponent(LancamentosDataset);
    LancamentosDatasetcliente_id.Name := 'LancamentosDatasetcliente_id';
    LancamentosDatasetcliente_id.FieldName := 'cliente_id';
    LancamentosDatasetfornecedor_id.SetParentComponent(LancamentosDataset);
    LancamentosDatasetfornecedor_id.Name := 'LancamentosDatasetfornecedor_id';
    LancamentosDatasetfornecedor_id.FieldName := 'fornecedor_id';
    LancamentosDatasetmodalidade_id.SetParentComponent(LancamentosDataset);
    LancamentosDatasetmodalidade_id.Name := 'LancamentosDatasetmodalidade_id';
    LancamentosDatasetmodalidade_id.FieldName := 'modalidade_id';
    LancamentosDatasetmodalidade_id.Required := True;
    LancamentosDatasetplano_contas_id.SetParentComponent(LancamentosDataset);
    LancamentosDatasetplano_contas_id.Name := 'LancamentosDatasetplano_contas_id';
    LancamentosDatasetplano_contas_id.FieldName := 'plano_contas_id';
    LancamentosDatasetplano_contas_id.Required := True;
    LancamentosDatasetconta_origem_id.SetParentComponent(LancamentosDataset);
    LancamentosDatasetconta_origem_id.Name := 'LancamentosDatasetconta_origem_id';
    LancamentosDatasetconta_origem_id.FieldName := 'conta_origem_id';
    LancamentosDatasetconta_origem_id.Required := True;
    LancamentosDatasetconta_destino_id.SetParentComponent(LancamentosDataset);
    LancamentosDatasetconta_destino_id.Name := 'LancamentosDatasetconta_destino_id';
    LancamentosDatasetconta_destino_id.FieldName := 'conta_destino_id';
    LancamentosDatasetfuncionario_id.SetParentComponent(LancamentosDataset);
    LancamentosDatasetfuncionario_id.Name := 'LancamentosDatasetfuncionario_id';
    LancamentosDatasetfuncionario_id.FieldName := 'funcionario_id';
    LancamentosDatasetdocumento.SetParentComponent(LancamentosDataset);
    LancamentosDatasetdocumento.Name := 'LancamentosDatasetdocumento';
    LancamentosDatasetdocumento.FieldName := 'documento';
    LancamentosDatasetdocumento.Size := 255;
    LancamentosDatasethistorico.SetParentComponent(LancamentosDataset);
    LancamentosDatasethistorico.Name := 'LancamentosDatasethistorico';
    LancamentosDatasethistorico.FieldName := 'historico';
    LancamentosDatasethistorico.Required := True;
    LancamentosDatasethistorico.Size := 255;
    LancamentosDatasetlancamento_credito.SetParentComponent(LancamentosDataset);
    LancamentosDatasetlancamento_credito.Name := 'LancamentosDatasetlancamento_credito';
    LancamentosDatasetlancamento_credito.FieldName := 'lancamento_credito';
    LancamentosDatasetlancamento_estorno.SetParentComponent(LancamentosDataset);
    LancamentosDatasetlancamento_estorno.Name := 'LancamentosDatasetlancamento_estorno';
    LancamentosDatasetlancamento_estorno.FieldName := 'lancamento_estorno';
    LancamentosDatasetlancamento_estorno.Required := True;
    LancamentosDatasetlancamento_prazo.SetParentComponent(LancamentosDataset);
    LancamentosDatasetlancamento_prazo.Name := 'LancamentosDatasetlancamento_prazo';
    LancamentosDatasetlancamento_prazo.FieldName := 'lancamento_prazo';
    LancamentosDatasetlancamento_prazo.Required := True;
    LancamentosDatasetdata_emissao.SetParentComponent(LancamentosDataset);
    LancamentosDatasetdata_emissao.Name := 'LancamentosDatasetdata_emissao';
    LancamentosDatasetdata_emissao.FieldName := 'data_emissao';
    LancamentosDatasetdata_emissao.Required := True;
    LancamentosDatasetdata_vencimento.SetParentComponent(LancamentosDataset);
    LancamentosDatasetdata_vencimento.Name := 'LancamentosDatasetdata_vencimento';
    LancamentosDatasetdata_vencimento.FieldName := 'data_vencimento';
    LancamentosDatasetdata_vencimento.Required := True;
    LancamentosDatasetdata_pagamento.SetParentComponent(LancamentosDataset);
    LancamentosDatasetdata_pagamento.Name := 'LancamentosDatasetdata_pagamento';
    LancamentosDatasetdata_pagamento.FieldName := 'data_pagamento';
    LancamentosDatasetdata_pagamento.Required := True;
    LancamentosDatasetvalor.SetParentComponent(LancamentosDataset);
    LancamentosDatasetvalor.Name := 'LancamentosDatasetvalor';
    LancamentosDatasetvalor.FieldName := 'valor';
    LancamentosDatasetvalor.Required := True;
    LancamentosDatasetobservacoes.SetParentComponent(LancamentosDataset);
    LancamentosDatasetobservacoes.Name := 'LancamentosDatasetobservacoes';
    LancamentosDatasetobservacoes.FieldName := 'observacoes';
    LancamentosDatasetobservacoes.Size := 255;
    LancamentosDatasetsaldo_inicial_origem.SetParentComponent(LancamentosDataset);
    LancamentosDatasetsaldo_inicial_origem.Name := 'LancamentosDatasetsaldo_inicial_origem';
    LancamentosDatasetsaldo_inicial_origem.FieldName := 'saldo_inicial_origem';
    LancamentosDatasetsaldo_inicial_destino.SetParentComponent(LancamentosDataset);
    LancamentosDatasetsaldo_inicial_destino.Name := 'LancamentosDatasetsaldo_inicial_destino';
    LancamentosDatasetsaldo_inicial_destino.FieldName := 'saldo_inicial_destino';
    LancamentosDatasetcodigo_interno.SetParentComponent(LancamentosDataset);
    LancamentosDatasetcodigo_interno.Name := 'LancamentosDatasetcodigo_interno';
    LancamentosDatasetcodigo_interno.FieldName := 'codigo_interno';
    LancamentosDatasetcodigo_interno.Required := True;
    LancamentosDatasetexcluido.SetParentComponent(LancamentosDataset);
    LancamentosDatasetexcluido.Name := 'LancamentosDatasetexcluido';
    LancamentosDatasetexcluido.FieldName := 'excluido';
    LancamentosDatasetinclusao.SetParentComponent(LancamentosDataset);
    LancamentosDatasetinclusao.Name := 'LancamentosDatasetinclusao';
    LancamentosDatasetinclusao.FieldName := 'inclusao';
    LancamentosDatasetalteracao.SetParentComponent(LancamentosDataset);
    LancamentosDatasetalteracao.Name := 'LancamentosDatasetalteracao';
    LancamentosDatasetalteracao.FieldName := 'alteracao';
    LancamentosDatasetexclusao.SetParentComponent(LancamentosDataset);
    LancamentosDatasetexclusao.Name := 'LancamentosDatasetexclusao';
    LancamentosDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := LancamentosDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 616;
    tmrConsulta.Top := 344;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    LancamentosDataset.AfterLoadDFMValues;
    LancamentosDatasetid.AfterLoadDFMValues;
    LancamentosDatasetaliado_id.AfterLoadDFMValues;
    LancamentosDatasetdata_base_id.AfterLoadDFMValues;
    LancamentosDatasetcliente_id.AfterLoadDFMValues;
    LancamentosDatasetfornecedor_id.AfterLoadDFMValues;
    LancamentosDatasetmodalidade_id.AfterLoadDFMValues;
    LancamentosDatasetplano_contas_id.AfterLoadDFMValues;
    LancamentosDatasetconta_origem_id.AfterLoadDFMValues;
    LancamentosDatasetconta_destino_id.AfterLoadDFMValues;
    LancamentosDatasetfuncionario_id.AfterLoadDFMValues;
    LancamentosDatasetdocumento.AfterLoadDFMValues;
    LancamentosDatasethistorico.AfterLoadDFMValues;
    LancamentosDatasetlancamento_credito.AfterLoadDFMValues;
    LancamentosDatasetlancamento_estorno.AfterLoadDFMValues;
    LancamentosDatasetlancamento_prazo.AfterLoadDFMValues;
    LancamentosDatasetdata_emissao.AfterLoadDFMValues;
    LancamentosDatasetdata_vencimento.AfterLoadDFMValues;
    LancamentosDatasetdata_pagamento.AfterLoadDFMValues;
    LancamentosDatasetvalor.AfterLoadDFMValues;
    LancamentosDatasetobservacoes.AfterLoadDFMValues;
    LancamentosDatasetsaldo_inicial_origem.AfterLoadDFMValues;
    LancamentosDatasetsaldo_inicial_destino.AfterLoadDFMValues;
    LancamentosDatasetcodigo_interno.AfterLoadDFMValues;
    LancamentosDatasetexcluido.AfterLoadDFMValues;
    LancamentosDatasetinclusao.AfterLoadDFMValues;
    LancamentosDatasetalteracao.AfterLoadDFMValues;
    LancamentosDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
  end;
end;

end.
